import { lazy } from 'react';

export const SupplierPageAsync = lazy(() => import('./SupplierPage'));
